import React, { useEffect, useState } from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaPinterestP, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaAngleUp, FaPaperPlane } from 'react-icons/fa';

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [subscribeError, setSubscribeError] = useState('');

  // Handle email subscription
  const handleSubscribe = (e) => {
    e.preventDefault();
    setSubscribeError(''); // Clear previous errors
    // Basic email validation (check for @ and .)
    if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setSubscribed(true);
      setEmail('');
      console.log('Subscription successful for:', email); // Simulate API call or actual logic
      // Reset subscription message after 3 seconds
      setTimeout(() => setSubscribed(false), 3000);
    } else {
      setSubscribeError('Please enter a valid email address.');
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Toggle scroll button visibility
  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.pageYOffset > 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
      <>
        {/* Footer Main */}
        <footer className="footer-area">
          <div className="footer-main pt-5 pb-4"> {/* Adjusted padding */}
            <div className="container">
              {/* Corrected Row with adjusted column widths */}
              <div className="row gy-4">

                {/* Column 1: About & App Download (lg-4) */}
                <div className="col-lg-4 col-md-6">
                  <div className="widget-item">
                    <div className="widget-about">
                      <a className="widget-logo mb-3 d-inline-block" href="/">
                        <img
                            className="logo-main"
                            src="/assets/images/logo.png" // Ensure this path is correct for your project
                            alt="Cressa Logo"
                        />
                      </a>
                      <p className="about-text mb-4">
                        Discover quality and style with Cressa. Your destination for premium products and exceptional
                        service.
                      </p>
                      <div className="app-download-section mb-4">
                        <p className="app-download-title">Download our mobile app</p>
                        <div className="app-store-badges">
                          <a
                              href="https://play.google.com/store/apps/details?id=com.hktech.cressa&pli=1"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="store-badge-link"
                              aria-label="Get it on Google Play"
                          >
                            <img
                                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                alt="Get it on Google Play"
                                className="store-badge"
                            />
                          </a>

                          <a
                              href="https://apps.apple.com/in/app/cressa/id6743152741"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="store-badge-link"
                              aria-label="Download on the App Store"
                          >
                            <img
                                src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg"
                                alt="Download on the App Store"
                                className="store-badge apple-badge"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Column 2: Quick Links (Changed to lg-3) */}
                <div className="col-lg-3 col-md-6 col-sm-6 col-6"> {/* Increased width */}
                  <div className="widget-item">
                    <h4 className="widget-title">Quick Links</h4>
                    <ul className="">
                      <li className="quick-link-item"><a href="/">Home</a></li>
                      <li className="quick-link-item"><a href="/about-us">About Us</a></li>
                      <li className="quick-link-item"><a href="/product">Products</a></li>
                      <li className="quick-link-item"><a href="/contact">Contact Us</a></li>
                      <li className="quick-link-item"><a href="/faq">FAQ</a></li>
                      <li className="quick-link-item"><a href="/privacy">Privacy Policy</a></li>
                    </ul>
                  </div>
                </div>

                {/* Column 3: Contact Info (lg-3) */}
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="widget-item">
                    <h4 className="widget-title">Contact Us</h4>
                    <div className="widget-contact">
                      <p className="contact-item">
                        <FaMapMarkerAlt className="contact-icon" />
                        <span>Shop No. 1,2,3, 2nd Fl, Indraprastha Complex, Varachha Main Rd, Surat, GJ 395006</span>
                      </p>
                      <p className="contact-item">
                        <FaPhoneAlt className="contact-icon" />
                        <a href="tel:+919712027909">+91 97120 27909</a>
                      </p>
                      <p className="contact-item">
                        <FaEnvelope className="contact-icon" />
                        <a href="mailto:cressa2024@gmail.com">cressa2024@gmail.com</a>
                      </p>
                      <p className="contact-item">
                        <FaClock className="contact-icon" />
                        <span>Mon-Sat: 10:00 AM - 8:00 PM</span>
                      </p>
                    </div>
                  </div>
                </div>

                {/* Column 4: Newsletter & Social (Changed to lg-2) */}
                <div className="col-lg-2 col-md-6"> {/* Decreased width */}
                  <div className="widget-item">
                    <h4 className="widget-title">Stay Connected</h4>
                    <div className="widget-newsletter mb-4">
                      <p>Subscribe to our newsletter for updates and promotions.</p>
                      <form onSubmit={handleSubscribe} className="newsletter-form">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                            aria-label="Email for newsletter"
                            className="form-control newsletter-input"
                        />
                        <button type="submit" className="btn newsletter-btn" aria-label="Subscribe">
                          <FaPaperPlane />
                        </button>
                      </form>
                      {subscribed && <p className="subscribe-success mt-2">Thank you for subscribing!</p>}
                      {subscribeError && <p className="subscribe-error mt-2">{subscribeError}</p>}
                    </div>

                    <h5 className="social-title mb-3">Follow Us</h5>
                    <div className="social-icons">
                      <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="social-icon facebook" aria-label="Facebook">
                        <FaFacebookF />
                      </a>
                      <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="social-icon twitter" aria-label="Twitter">
                        <FaTwitter />
                      </a>
                      <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="social-icon instagram" aria-label="Instagram">
                        <FaInstagram />
                      </a>
                      <a href="https://www.pinterest.com/" target="_blank" rel="noopener noreferrer" className="social-icon pinterest" aria-label="Pinterest">
                        <FaPinterestP />
                      </a>
                    </div>
                  </div>
                </div>

              </div> {/* End Row */}
            </div> {/* End Container */}
          </div> {/* End Footer Main */}

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
                  <p className="copyright mb-0">
                    © {new Date().getFullYear()} Cressa. All rights reserved.
                  </p>
                </div>
                <div className="col-md-6 text-center text-md-end">
                  <span className="design-credit">Designed with <span style={{color: '#e25555'}}>❤</span></span>
                </div>
              </div>
            </div>
          </div>
        </footer>

        {/* Scroll Top Button */}
        {isVisible && (
            <button
                id="scroll-to-top"
                className="scroll-to-top"
                onClick={scrollToTop}
                aria-label="Scroll to top"
                style={{ opacity: isVisible ? '1' : '0', visibility: isVisible ? 'visible' : 'hidden' }}
            >
              <FaAngleUp />
            </button>
        )}

        {/* Style block for improved organization */}
        <style jsx>{`
          .footer-area {
            color: #ccc; /* Default text color */
            font-size: 15px;
          }

          .footer-main {
            background-color: #222;
            background-image: linear-gradient(to bottom, #252525, #1e1e1e);
            position: relative;
            overflow: hidden;
          }

          .widget-item {
            margin-bottom: 20px;
          }
          
          

          .widget-title {
            font-size: 1.25rem;
            color: #fff;
            margin-bottom: 25px;
            font-weight: 600;
            position: relative;
            padding-bottom: 12px;
            text-transform: capitalize;
          }
          .widget-title::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 40px;
            height: 3px;
            background-color: #D4B675;
            transition: width 0.3s ease-in-out;
          }
          .widget-item:hover .widget-title::after {
            width: 60px;
          }

          /* About Widget */
          .widget-logo img {
            max-width: 150px;
            height: auto;
            object-fit: contain;
            transition: transform 0.3s ease;
          }
          .widget-logo:hover img {
            transform: scale(1.05);
          }

          .app-store-badges {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            margin-top: 10px;
          }

          .store-badge-link {
            display: inline-block;
            transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;
            border-radius: 8px;
            overflow: hidden;
          }

          .store-badge-link:hover {
            transform: translateY(-3px);
            box-shadow: 0 6px 15px rgba(212, 182, 117, 0.2);
          }

          .store-badge {
            height: 55px;
            max-width: 100%;
            display: block;
          }

          .apple-badge {
            height: 40px;
            margin-top: 7.5px; /* To align with the Play Store badge */
          }

          @media (max-width: 575.98px) {
            .app-store-badges {
              flex-direction: column;
              align-items: flex-start;
            }

            .apple-badge {
              margin-top: 0;
            }
          }
          
          .about-text {
            color: #bbb;
            line-height: 1.6;
          }
          .app-download-title {
            color: #ddd;
            margin-bottom: 10px;
            font-size: 14px;
            font-weight: 500;
          }
          .playstore-link {
            display: inline-block;
            transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;
            border-radius: 8px;
            overflow: hidden;
          }
          .playstore-link:hover {
            transform: translateY(-3px);
            box-shadow: 0 6px 15px rgba(212, 182, 117, 0.2);
          }
          .playstore-badge {
            height: 55px;
            max-width: 100%;
            display: block;
          }


          /* Quick Links Widget */
          .widget-nav {
            list-style: none;
            padding: 0;
            margin: 0;
          }
          .quick-link-item {
            margin-bottom: 12px;
            transition: padding-left 0.3s ease;
          }
          .quick-link-item a {
            color: #ccc;
            text-decoration: none;
            transition: color 0.3s ease;
            display: flex;
            align-items: center;
            position: relative;
          }
          .quick-link-item a::before {
            content: '\\2023'; /* Bullet point */
            font-family: 'react-icons/fa'; /* Or use a real icon */
            color: #D4B675;
            margin-right: 8px;
            font-size: 10px;
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          .quick-link-item:hover a {
            color: #D4B675 !important;
            padding-left: 5px;
          }
          .quick-link-item:hover a::before {
            opacity: 1;
          }


          /* Contact Widget */
          .widget-contact .contact-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: 15px;
            color: #ccc;
            line-height: 1.6;
          }
          .widget-contact .contact-icon {
            color: #D4B675;
            margin-right: 15px;
            margin-top: 4px;
            flex-shrink: 0;
            font-size: 18px;
          }
          .widget-contact .contact-item a {
            color: #ccc;
            text-decoration: none;
            transition: color 0.3s ease;
          }
          .widget-contact .contact-item a:hover {
            color: #D4B675;
            text-decoration: underline;
          }


          /* Newsletter & Social Widget */
          .widget-newsletter p {
            margin-bottom: 15px;
            color: #bbb;
          }
          .newsletter-form {
            display: flex;
            position: relative;
          }
          .newsletter-input {
            flex-grow: 1;
            padding: 10px 15px;
            border: 1px solid #444;
            background-color: #333;
            color: #fff;
            border-radius: 25px 0 0 25px;
            height: 48px;
            font-size: 14px;
            transition: border-color 0.3s ease, box-shadow 0.3s ease;
          }
          .newsletter-input:focus {
            background-color: #404040;
            border-color: #D4B675;
            box-shadow: 0 0 0 3px rgba(212, 182, 117, 0.3);
            outline: none;
          }
          .newsletter-input::placeholder {
            color: #888;
          }

          .newsletter-btn {
            background-color: #D4B675;
            color: #222;
            border: none;
            padding: 10px 18px;
            border-radius: 0 25px 25px 0;
            cursor: pointer;
            transition: background-color 0.3s ease, transform 0.2s ease;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
          }
          .newsletter-btn:hover {
            background-color: #c0a35f;
            transform: scale(1.05);
          }
          .subscribe-success {
            color: #79d89d;
            font-size: 14px;
            font-weight: 500;
          }
          .subscribe-error {
            color: #e57373;
            font-size: 14px;
            font-weight: 500;
          }
          .social-title {
            font-size: 1rem;
            color: #fff;
            font-weight: 500;
          }
          .social-icons {
            display: flex;
            gap: 12px;
          }
          .social-icon {
            background-color: rgba(212, 182, 117, 0.15);
            color: #D4B675;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
            border: 1px solid rgba(212, 182, 117, 0.3);
            font-size: 16px;
          }
          .social-icon:hover {
            background-color: #D4B675;
            color: #fff;
            transform: translateY(-3px) scale(1.1);
            box-shadow: 0 4px 10px rgba(212, 182, 117, 0.3);
          }


          /* Footer Bottom */
          .footer-bottom {
            background-color: #1a1a1a;
            padding: 20px 0;
            border-top: 1px solid rgba(255, 255, 255, 0.08);
            font-size: 14px;
          }
          .copyright {
            color: #aaa;
          }
          .design-credit {
            color: #aaa;
          }


          /* Scroll Top Button */
          .scroll-to-top {
            position: fixed;
            right: 25px;
            bottom: 25px;
            z-index: 1000;
            background-color: #D4B675;
            color: #fff;
            width: 48px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            cursor: pointer;
            box-shadow: 0 4px 12px rgba(0,0,0,0.2);
            transition: all 0.3s ease-in-out;
            border: none;
            opacity: 0;
            visibility: hidden;
            transform: translateY(10px);
          }
          .scroll-to-top[style*="opacity: 1"] {
            transform: translateY(0);
          }
          .scroll-to-top:hover {
            background-color: #c0a35f;
            transform: translateY(-3px);
            box-shadow: 0 6px 15px rgba(212, 182, 117, 0.3);
          }
          .scroll-to-top svg {
            font-size: 22px;
          }

          /* Responsive Adjustments */
          @media (max-width: 991.98px) { /* Adjust Bootstrap's lg breakpoint */
            .widget-title { font-size: 1.15rem; margin-bottom: 20px; }
            .footer-main { padding-top: 40px; padding-bottom: 10px; }
            /* Ensure newsletter form doesn't break badly */
            .newsletter-input { font-size: 13px; }
            .newsletter-btn { padding: 10px 15px; }
            /* Quick links might still wrap, which is okay on medium */
          }
          @media (max-width: 767.98px) { /* Adjust Bootstrap's md breakpoint */
            .footer-bottom .col-md-6 { text-align: center !important; }
            .footer-bottom .design-credit { margin-top: 8px; display: block; }
            .widget-item { margin-bottom: 30px; }
            /* Stack newsletter input/button */
            .newsletter-form { flex-direction: column; }
            .newsletter-input { border-radius: 25px; margin-bottom: 10px; }
            .newsletter-btn { border-radius: 25px; width: 100%; }
            .scroll-to-top { width: 42px; height: 42px; right: 15px; bottom: 15px; }
            .scroll-to-top svg { font-size: 18px; }
          }
          @media (max-width: 575.98px) { /* Adjust Bootstrap's sm breakpoint */
            /* Further adjustments if needed for very small screens */
            .widget-title { font-size: 1.1rem; }
            .about-text, .widget-newsletter p, .contact-item { font-size: 14px; }
          }

        `}
        </style>
      </>
  );
};

export default Footer;